<script lang="tsx">
  import { Skeleton } from "primevue";
  import Form from "./Form.vue";
  import FormSkeleton from "./FormSkeleton.vue";

  export default {
    components: { Form, FormSkeleton },
    props: Form.props as (typeof Form["props"]),
  };
</script>

<template>
  <Suspense v-bind.attr="$attrs">
    <Form v-bind.attr="$attrs" v-bind.prop="{
    ...$props as any, initialValues: JSON.parse(($props as any)?.initialValues ??
    '{}')
    }"/>

    <template #fallback>
      <FormSkeleton/>
    </template>
  </Suspense>
</template>
